export const EquationCardFunction = () =>{
    return(
        <div className="container">
            <p>数式エディタのカードの対象カードパラメータの計算方法をしていします</p>
            <img src={`${process.env.PUBLIC_URL}/equation_card_function.png`}></img>
            <p>図の例ではカードパラメータの最大値を表しています。ほかにはSUMがカードパラメータの合計、MINがカードパラメータの最小値です</p>
            </div>
    )
}
